'use strict';

/**
 * VendorModule — vendor profile, balance, merchants, transactions, dashboard.
 * All calls are direct paymentSystem calls (rawGet / rawPost) using the
 * stored JWT token.
 */
class VendorModule {
  constructor(client) {
    this._c = client;
  }

  // ── Profile ──────────────────────────────────────────────────────

  getProfile()               { return this._c.rawGet('/api/v1/vendor/profile'); }
  updateProfile(body)        { return this._c.rawPost('/api/v1/vendor/profile/update', body); }

  // ── Balance / Wallet ─────────────────────────────────────────────

  getBalance()               { return this._c.rawGet('/api/v1/vendor/wallet/balance'); }
  getWalletStatement(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/vendor/wallet/statement${qs}`);
  }

  // ── Dashboard ────────────────────────────────────────────────────

  getDashboard()             { return this._c.rawGet('/api/v1/vendor/dashboard'); }

  // ── Merchants ────────────────────────────────────────────────────

  listMerchants(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/vendor/merchants${qs}`);
  }

  getMerchant(merchantId)    { return this._c.rawGet(`/api/v1/vendor/merchants/${merchantId}`); }
  createMerchant(body)       { return this._c.rawPost('/api/v1/vendor/merchants/create', body); }
  updateMerchant(merchantId, body) {
    return this._c.rawPost(`/api/v1/vendor/merchants/${merchantId}/update`, body);
  }

  // ── Transactions ─────────────────────────────────────────────────

  listTransactions(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/vendor/transactions${qs}`);
  }

  getTransaction(txnId) {
    return this._c.rawGet(`/api/v1/vendor/transactions/${txnId}`);
  }

  // ── Commission ───────────────────────────────────────────────────

  listCommissionConfigs(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/vendor/commission${qs}`);
  }

  createCommissionConfig(body) {
    return this._c.rawPost('/api/v1/vendor/commission/create', body);
  }

  updateCommissionConfig(configId, body) {
    return this._c.rawPost(`/api/v1/vendor/commission/${configId}/update`, body);
  }

  deleteCommissionConfig(configId) {
    return this._c.rawPost(`/api/v1/vendor/commission/${configId}/delete`, {});
  }
}

module.exports = { VendorModule };
